import React from 'react';

const WizardNavigation = ({
        currentStep,
        totalSteps,
        onNext,
        onBack,
        onFinish,
        canGoNext = true,
        nextLabel = 'Next',
        showBack = true,
}) => {
        const isFirstStep = currentStep === 0;
        const isLastStep = currentStep === totalSteps - 1;
        const showStepCounter = totalSteps > 1;

        return (
                <div className="flex items-center justify-between pt-6 border-t border-gray-200">
                        {/* Back Button */}
                        <div>
                                {showBack && !isFirstStep && (
                                        <button
                                                onClick={onBack}
                                                data-testid="wizard-back"
                                                className="px-6 py-2 text-gray-600 hover:text-gray-800 font-medium transition-colors"
                                        >
                                                ← Back
                                        </button>
                                )}
                        </div>

                        {/* Step Counter */}
                        {/*{showStepCounter && (
                                <div className="text-sm text-gray-500">
                                        Step {currentStep + 1} of {totalSteps}
                                </div>
                        )}
                        */}

                        {/* Next/Finish Button */}
                        <div>
                                {isLastStep ? (
                                        <button
                                                onClick={onFinish}
                                                data-testid="wizard-finish"
                                                disabled={!canGoNext}
                                                className="bg-brand hover:bg-brand/90 text-white px-6 py-2 rounded font-medium disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
                                        >
                                                Finish
                                        </button>
                                ) : (
                                        <button
                                                onClick={onNext}
                                                data-testid="wizard-next"
                                                disabled={!canGoNext}
                                                className="bg-brand hover:bg-brand/90 text-white px-6 py-2 rounded font-medium disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
                                        >
                                                {nextLabel} →
                                        </button>
                                )}
                        </div>
                </div>
        );
};

export default WizardNavigation;
